import { useMemo } from 'react';
import { Cohort, Segment } from 'domains/segments/types';
import useFeatureSettings from 'hooks/queries/useFeatureSettings';
import useSegmentCohorts from 'hooks/queries/useSegmentCohorts';
import useSegments from 'hooks/queries/useSegments';

type AudienceIdentifier = {
    segmentId?: number;
    cohortId?: string;
};

const useAudienceData = ({ segmentId, cohortId }: AudienceIdentifier) => {
    const { data: featureSettings } = useFeatureSettings();

    // Cohorts are only available when platform is integrated
    const isPlatformIntegrated = featureSettings?.platformIntegrated;
    const isCohortEnabled = isPlatformIntegrated && Boolean(cohortId);

    const { data: audiences } = useSegments({
        enabled: Boolean(segmentId),
    });

    const { data: cohorts } = useSegmentCohorts({
        reactQueryOptions: { enabled: isCohortEnabled },
    });

    const currentAudience = useMemo(() => {
        if (segmentId && audiences) {
            return audiences.find((audience: Segment) => audience.id === segmentId);
        }
        if (cohortId && cohorts?.data) {
            return cohorts.data.find((cohort: Cohort) => cohort.id === cohortId);
        }
        return null;
    }, [segmentId, cohortId, audiences, cohorts?.data]);

    return { currentAudience };
};

export default useAudienceData;
